<div class="acca-boost-applied">
    @if (ladderItems().length > 0) {
        <vn-icon name="theme-success-i" class="acca-boost-success-icon" size="14" />
        <div class="acca-boost-return acca-boost-us-font-common">
            @if (isMaxReward) {
                <span> {{ maxItem.ratio | msAccaBoostRatio: false }}&nbsp;{{ sitecore.accaBoost.ParlayBoost }} </span>
            } @else {
                <span> {{ ladderItems()[0].ratio | msAccaBoostRatio: false }}&nbsp;{{ sitecore.accaBoost.ParlayBoost }} </span>
            }
        </div>
    }
</div>
@if (isMaxReward) {
    <div class="acca-boost-us-font-common">{{ sitecore.accaBoost.MaxWinnings }}{{ notification.token.maxReward | bsCurrency: true }}</div>
} @else {
    @if (showLadder) {
        <div class="acca-boost-list acca-boost-us-font-common">
            @if (nextLadderItems.length > 0) {
                @for (item of nextLadderItems; let last = $last; track item) {
                    <div class="acca-boost-space">
                        {{ item.ratio | msAccaBoostRatio: false : sitecore.accaBoost.For | msInterpolate: { numberOfPicks: item.numberOfLegs }
                        }}{{ !last ? ',' : '' }}
                    </div>
                }
                <div class="acca-boost-more acca-boost-us-font-common" (click)="onClickInfo($event)">{{ sitecore.accaBoost.AndMore }}</div>
            }
        </div>
    }
    @if (isMaxLegAway) {
        <div class="acca-boost-us-font-common">
            {{ maxItem.ratio | msAccaBoostRatio: false : sitecore.accaBoost.MaxLegsAway }}
        </div>
    }
    @if (pickCount >= maxItem.numberOfLegs) {
        <div class="acca-boost-us-font-common">
            {{ sitecore.accaBoost.MaxLegsReached }}
        </div>
    }
}
